import { createIcon, type IconProps } from '@chakra-ui/react';
import React from 'react';

const Arrowhead = createIcon({
  displayName: 'ArrowheadIcon',
  defaultProps: { transition: 'transform 0.2s easeIn' },
  viewBox: '0 0 8 5',
  d: 'M.47.47a.75.75 0 0 1 1.06 0L4 2.94 6.47.47a.75.75 0 0 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06',
});

const ROTATION_BY_DIRECTION = {
  down: 0,
  left: 90,
  right: -90,
  up: 180,
} as const;

interface ArrowheadProps extends Omit<IconProps, 'css'> {
  direction: keyof typeof ROTATION_BY_DIRECTION;
}

const ArrowheadIcon = ({ direction, ...props }: ArrowheadProps) => {
  return <Arrowhead {...props} transform={`rotate(${ROTATION_BY_DIRECTION[direction]}deg)`} />;
};

export default React.memo(ArrowheadIcon);
